import styled from 'styled-components';

export const Container = styled.div`
  display: -webkit-flex;
  flex-direction: column;

  margin: 2vh 3vw 3vh 3vw;
  min-height: max-content;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding-top: 8px;

`;

export const PageTitle = styled.div`
  padding: 15px 0 25px;
  margin-bottom: 3px;

  h1 {
    font-size: 28px;
    font-weight: 700;
    color: #263238;
    margin-bottom: 4px;
  }

  h3 {
    position: relative;
    font-size: 16px;
    color: #b1b1b1;
    font-weight: 400;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      height: 1px;
      width: 15px;
      background: #b1b1b1;
    }
  }
`;

export const AdvancedSearch = styled.div`
  display: -webkit-flex;
  flex-direction: row;
  gap: 8px;
  flex-direction: column;
  margin-bottom: 15px;
  min-height: max-content;

  @media (min-width: 500px) {
    flex-direction: row;
  }

  .group__tenant {
    flex-basis: 40%;
  }

  .group__tenant__search {
    display: flex;
    align-items: flex-end;
    flex-basis: 60%;
  }

  .group {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 16px;

    @media (min-width: 768px) {
      flex-direction: row;
    }
  }

  .group__input {
    display: flex;
    flex: 1;
    gap: 16px;
    flex-direction: column;

    @media (min-width: 500px) {
      flex-direction: row;
    }
  }
`;

export const InputWrapper = styled.div`
  display: -webkit-flex;
  flex-direction: column;

  min-height: max-content;

  flex: 1;
`;

export const TotalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 0;
  margin-top: 8px;

  span {
    font-size: 16px;
    font-weight: 600;
    color: #263238;

    strong {
      font-size: 18px;
      color: #4caf50;
      margin-left: 8px;
    }
  }
`;
